export default function hasRecommendations(recommendationsData) {
  return recommendationsData?.recommendations?.length > 0;
}
